import { ReadyRouteStatusEnum } from '@routellers/types/dist/city-ready-route/enum/ready-route-status.enum';
import { CityQuestStatusEnum } from '@routellers/types/dist/city-quest/enum/city-quest-status.enum';
import { Badge } from '@mantine/core';

import { t } from '../dictionary';

const questColors: Record<CityQuestStatusEnum, string> = {
    [CityQuestStatusEnum.DRAFT]: 'gray',
    [CityQuestStatusEnum.NEED_REVIEW]: 'yellow',
    [CityQuestStatusEnum.REJECTED]: 'red',
    [CityQuestStatusEnum.READY]: 'indigo',
    [CityQuestStatusEnum.PAUSED]: 'blue',
};

const routeColors: Record<ReadyRouteStatusEnum, string> = {
    [ReadyRouteStatusEnum.DRAFT]: 'gray',
    [ReadyRouteStatusEnum.NEED_REVIEW]: 'yellow',
    [ReadyRouteStatusEnum.REJECTED]: 'red',
    [ReadyRouteStatusEnum.PUBLISHED]: 'indigo',
};

export const StoryStatusBadge = ({ status }: { status: CityQuestStatusEnum | string }) => (
    <Badge variant='light' color={questColors[status as CityQuestStatusEnum] || 'gray'}>
        {t.stories.statuses[status as keyof typeof t.stories.statuses] || status}
    </Badge>
);

export const RouteStatusBadge = ({ status }: { status: ReadyRouteStatusEnum | string }) => (
    <Badge variant='light' color={routeColors[status as ReadyRouteStatusEnum] || 'gray'}>
        {t.routes.statuses[status as keyof typeof t.routes.statuses] || status}
    </Badge>
);
